import { getTokenDefinition, GetTokenDefinitionResponse } from "./getTokenDefinition";

export interface ITemporaryAccessAPI {
  getTokenDefinition(token: string): Promise<GetTokenDefinitionResponse | undefined>;
}

const TemporaryAccess: ITemporaryAccessAPI = {
  getTokenDefinition
}

export default TemporaryAccess;
